import { create } from 'zustand';
import { IExercise } from '../../../core/models/exercise';

interface IExercisesFilterList {
  favorite?: boolean;
  unanswered?: boolean;
  wrongAnswer?: boolean;
  rightAnswer?: boolean;
  difficulty?: string[];
  selectedYear?: string[];
  institutionType?: string[];
  trial?: string;
  questions?: string[];
  selectedSubjects?: string[];
  isEnem?: string[];
  page: number;
  module?: string;
}

//Store para os exercicios carregados
interface ExercisePageState {
  exercises: IExercise[];
  fullExerciseList: { slug: string, id: string }[];
  actualExercise: IExercise | null;
  nextExercise: IExercise | null;
  previousExercise: IExercise | null;
  exercisesFilterList: IExercisesFilterList | null;
  fullExerciseFilterList: IExercisesFilterList | null;
  setExercises: (exercises: IExercise[]) => void;
  setFullExerciseList: (fullExerciseList: { slug: string, module: string, id: string }[]) => void;
  setFullExerciseFilterList: (fullExerciseFilterList: IExercisesFilterList) => void;
  setActualExercise: (exercise: IExercise) => void;
  setNextExercise: (exercise: IExercise) => void;
  setPreviousExercise: (exercise: IExercise) => void;
  setExercisesFilterList: (exercisesFilterList: IExercisesFilterList) => void;
  resetAll: () => void;
}

export const useExercisePageStore = create<ExercisePageState>()(
    (set) => ({
      exercises: [],
      fullExerciseList: [],
      fullExerciseFilterList: null,
      actualExercise: null,
      nextExercise: null,
      previousExercise: null,
      exercisesFilterList: null,
      setExercises: (exercises: IExercise[]) => set({ exercises }),
      setFullExerciseList: (fullExerciseList: { slug: string, module: string, id: string }[]) => set({ fullExerciseList }),
      setFullExerciseFilterList: (fullExerciseFilterList: IExercisesFilterList) => set({ fullExerciseFilterList }),
      setActualExercise: (exercise: IExercise) => set({ actualExercise: exercise }),
      setNextExercise: (exercise: IExercise) => set({ nextExercise: exercise }),
      setPreviousExercise: (exercise: IExercise) => set({ previousExercise: exercise }),
      setExercisesFilterList: (exercisesFilterList: IExercisesFilterList) => set({ exercisesFilterList }),
      resetAll: () => set({
        exercises: [],
        actualExercise: null,
        nextExercise: null,
        previousExercise: null,
        exercisesFilterList: null,
      }),
    })
);
